import { CardContent } from '@src/components/Editor/types'

export const flagCardsForDemoText = (
  cards: CardContent[],
  endIndex: number
): CardContent[] =>
  cards.slice(0, endIndex).map(card => ({
    ...card,
    showDemoSuggestionText: true,
  }))



// WEBPACK FOOTER //
// ./src/utils/cards.ts